import { render, staticRenderFns } from "./ListProduct.vue?vue&type=template&id=0f03dc54"
import script from "./ListProduct.vue?vue&type=script&lang=js"
export * from "./ListProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports